<template>
  <div :style="'width: ' + size + '%;'">
    <label
      class="w-100 text-left"
      style="text-align:left;"
      v-if="nombre != null"
    >
      {{ nombre }}
    </label>
    <select
      class="form-select embajadores-dropdown"
      @change="ObtenerValor($event)"
      ref="valorselect"
      :required="requerido"
      :disabled="disabled"
    >
      <option
        :value="null"
        disabled
        selected
        class="embajadores-dropdown--placeholder"
      >
        {{ placeholder }}
      </option>
      <option
        v-for="index in arreglo"
        v-bind:key="index[llave]"
        v-bind:value="index[valor]"
      >
        {{ index[texto] }}
      </option>
    </select>
    <div
      v-show="requerido == true"
      class="invalid-feedback"
      style="text-align: left; font-family: 'Poppins'"
    >
      {{ invalidFeedback }}
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: "DropDown",
  watch: {
    "value": {handler (val) {
      this.$nextTick(() => {
        if(this.$refs.valorselect) {
          if( val !== null ) {
            this.$refs.valorselect.value = val;
          } else {
            this.$refs.valorselect.value = "";
          }
        }
      });
    }, immediate: true}
  },
  methods: {
    //change - mantener base de datos
    ObtenerValor(valorevento) {
        this.$emit("input", Number(valorevento.target.value));
    }
  },
  props: {
    nombre: String,
    arreglo: Array,
    llave: String,
    valor: String,
    texto: String,
    value: Number,
    requerido: Boolean,
    placeholder: String,
    disabled: Boolean,
    invalidFeedback: String,
    size: {
      type: Number,
      required: false,
      default: 100
    }
  },
  mounted() {
      //this.valor = this.value;
  }
};
</script>
<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.embajadores-dropdown {
  cursor: pointer;
  -webkit-appearance: none;
  border: 1px solid $color-primario;
  border-radius: 0px;
  font-family: "Poppins";
  color: #000000;
  font-weight: 400;
  background: url("../../../../../assets/iconos-embajadores/frame.png")
    no-repeat right rgba(184, 114, 90, 0.02);
  -webkit-appearance: none;
  background-position-x: 100%;
  background-size: contain;
}
.embajadores-dropdown .is-invalid,
.was-validated .form-select:invalid {
  border: 2px solid #fa0000;
  background-color: #ffffff;
  background-image: url("../../../../../assets/iconos-embajadores/arrowcopperinvalid.png") !important;
  background-repeat: no-repeat;
  background-position: right;
  background-size: auto !important;
}
.embajadores-dropdown .is-valid,
.was-validated .form-select:valid {
  border: 1px solid $color-primario !important;
  background-image: url("../../../../../assets/iconos-embajadores/frame.png") !important;
  background-repeat: no-repeat;
  background-size: auto !important;
  background-position-x: 100% !important;
  background-size: contain !important;
}
.embajadores-dropdown:focus {
  border-color: $color-primario !important;
}
.embajadores-dropdown:disabled {
  background-color: rgba(184, 114, 90, 0.082);
  color: rgba(0, 0, 0, 0.3);
  cursor: not-allowed;
}
@media all and (max-width: 767px) {
  .embajadores-dropdown {
    height: 45px;
    font-size: 13px;
    background-position-x: 100%;
  }
}
</style>
